import PropTypes from 'prop-types';

const FOREST_600 = '#16a34a';

/**
 * Mountain mark used on yahen-site Header and Footer.
 */
export default function YahenLogoMark({ size = 28, color = FOREST_600 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="m8 3 4 8 5-5 5 15H2L8 3z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

YahenLogoMark.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string
};
